// Mock data for United Christian Fellowship website
import wilson from './assets/leadership/wilson-kadavil.jpg';
import joshua from './assets/leadership/joshua-john.png';
import sam from './assets/leadership/sam-david.jpg';
import maneesh from './assets/leadership/maneesh-thomas.jpg';
import thomas from './assets/leadership/thomas-varghese.jpg';
import shiju from './assets/leadership/shiju-mathew.jpg';
import francis from './assets/leadership/francis-alexander.jpg';
import jacob from './assets/leadership/jacob-thomas.jpg';
import sooraj from './assets/leadership/sooraj-chakkapan.jpg';
import praise from './assets/leadership/praise-abraham.jpg';
import ajith from './assets/leadership/ajith-john.jpg';
import joseph from './assets/leadership/joseph-george.jpg';
import joel from './assets/leadership/joel-thomas.jpg';
import joji from './assets/leadership/joji-thomas.jpg';
import joshuak from './assets/leadership/joshua-kuriakose.png';


export const committeeMembers = [
  {
    id: 1,
    name: "PR. WILSON KADAVIL",
    position: "General President",
    image: wilson
  },
  {
    id: 2,
    name: "PR. JOSHUA JOHN",
    position: "Vice President",
    image: joshua
  },
  {
    id: 3,
    name: "PR. SAM DAVID",
    position: "Vice President",
    image: sam
  },
  {
    id: 4,
    name: "PR. MANEESH THOMAS",
    position: "General Secretary",
    image: maneesh
  },
  {
    id: 5,
    name: "THOMAS VARGHESE",
    position: "General Treasurer",
    image: thomas
  },
  {
    id: 6,
    name: "Br. SOORAJ CHAKKAPEN",
    position: "Joint Secretary",
    image: sooraj
  },
  {
    id: 7,
    name: "PR. JACOB THOMAS",
    position: "Committee Member",
    image: jacob
  },
  {
    id: 8,
    name: "PR. JOSEPH GEORGE",
    position: "Committee Member",
    image: joseph
  },
  {
    id: 9,
    name: "BR. PRAISE ABRAHAM",
    position: "Committee Member",
    image: praise
  },
  {
    id: 10,
    name: "PR. FRANCIS ALEXANDER",
    position: "Publicity Co-ordinator",
    image: francis
  },
  {
    id: 11,
    name: "PR. AJITH JOHN",
    position: "Youth Co-ordinator",
    image: ajith
  },
  {
    id: 12,
    name: "EVG. SHIJU MATHEW",
    position: "Prayer Co-ordinator",
    image: shiju
  },
  {
    id: 13,
    name: "JOSHUA KURIAKOSE",
    position: "Community Relation Co-ordinator",
    image: joshuak
  },
  {
    id: 14,
    name: "PR. JOJI THOMAS",
    position: "Evangelism Co-ordinator",
    image: joji
  },
  {
    id: 15,
    name: "BR. JOEL THOMAS",
    position: "Media Co-ordinator",
    image: joel
  }
];

export const events = [
  {
    id: 1,
    title: "Annual Music Fest 2025",
    date: "March 15, 2025",
    location: "Edmonton Convention Center",
    description: "Join us for a powerful night of worship with local and international artists. Experience the presence of God through music and fellowship.",
    image: "https://images.unsplash.com/photo-1602022578110-fbfad5644f7f?w=800",
    featured: true
  },
  {
    id: 2,
    title: "Unity Convention 2025",
    date: "April 20-22, 2025",
    location: "UCF Main Campus",
    description: "Three days of powerful teachings, worship, and networking with church leaders from across the nation.",
    image: "https://images.unsplash.com/photo-1573339886518-264aa6f194b2?w=800",
    featured: true
  },
  {
    id: 3,
    title: "Leadership Conference",
    date: "May 10, 2025",
    location: "Online & In-Person",
    description: "Equipping the next generation of church leaders with vision, strategy, and spiritual wisdom.",
    image: "https://images.unsplash.com/photo-1565813086292-604790c8a97b?w=800",
    featured: true
  },
  {
    id: 4,
    title: "Youth Revival Night",
    date: "June 5, 2025",
    location: "Edmonton Youth Center",
    description: "A night dedicated to empowering young believers with faith, purpose, and passion for Christ.",
    image: "https://images.unsplash.com/photo-1695938746747-ec185ea81325?w=800",
    featured: false
  },
  {
    id: 5,
    title: "Family Camp 2025",
    date: "July 12-15, 2025",
    location: "Pine Valley Retreat",
    description: "Strengthen family bonds through worship, teaching, and outdoor activities in a beautiful setting.",
    image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800",
    featured: false
  },
  {
    id: 6,
    title: "Prayer Summit",
    date: "August 8, 2025",
    location: "UCF Prayer Center",
    description: "Corporate prayer gathering for breakthrough, revival, and transformation in our cities.",
    image: "https://images.unsplash.com/photo-1729089049653-24312fdca908?w=800",
    featured: false
  }
];

export const sermons = [
  {
    id: 1,
    title: "Walking in Unity",
    speaker: "PR. Wilson Kadavil",
    date: "December 15, 2024",
    duration: "45:30",
    thumbnail: "https://images.unsplash.com/photo-1515616227676-603a1c547b3b?w=800",
    videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    description: "Exploring the biblical foundation of unity in the body of Christ."
  },
  {
    id: 2,
    title: "The Power of Worship",
    speaker: "PR. Joshua John",
    date: "December 8, 2024",
    duration: "38:15",
    thumbnail: "https://images.unsplash.com/photo-1667068114508-0055f7fb25a3?w=800",
    videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    description: "Understanding worship as a lifestyle, not just a Sunday experience."
  },
  {
    id: 3,
    title: "Building Strong Communities",
    speaker: "PR. Sam David",
    date: "December 1, 2024",
    duration: "42:00",
    thumbnail: "https://images.unsplash.com/photo-1565813086292-604790c8a97b?w=800",
    videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    description: "Practical steps to fostering genuine fellowship and community."
  },
  {
    id: 4,
    title: "Faith in Action",
    speaker: "PR. Maneesh Thomas",
    date: "November 24, 2024",
    duration: "40:20",
    thumbnail: "https://images.unsplash.com/photo-1655636237961-1fa3457c19a9?w=800",
    videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    description: "Moving beyond belief to demonstrating faith through works."
  }
];

export const mediaGallery = [
  {
    id: 1,
    type: "image",
    title: "Sunday Service",
    url: "https://images.unsplash.com/photo-1759127481171-30a27de310ad?w=800",
    thumbnail: "https://images.unsplash.com/photo-1759127481171-30a27de310ad?w=400"
  },
  {
    id: 2,
    type: "image",
    title: "Worship Night",
    url: "https://images.unsplash.com/photo-1667068114532-97a1ce6d0a52?w=800",
    thumbnail: "https://images.unsplash.com/photo-1667068114532-97a1ce6d0a52?w=400"
  },
  {
    id: 3,
    type: "image",
    title: "Community Fellowship",
    url: "https://images.unsplash.com/photo-1695938746747-ec185ea81325?w=800",
    thumbnail: "https://images.unsplash.com/photo-1695938746747-ec185ea81325?w=400"
  },
  {
    id: 4,
    type: "image",
    title: "Prayer Meeting",
    url: "https://images.unsplash.com/photo-1729089049653-24312fdca908?w=800",
    thumbnail: "https://images.unsplash.com/photo-1729089049653-24312fdca908?w=400"
  },
  {
    id: 5,
    type: "image",
    title: "Youth Service",
    url: "https://images.unsplash.com/photo-1650480929348-64f04d51db40?w=800",
    thumbnail: "https://images.unsplash.com/photo-1650480929348-64f04d51db40?w=400"
  },
  {
    id: 6,
    type: "image",
    title: "Conference 2024",
    url: "https://images.unsplash.com/photo-1602022578110-fbfad5644f7f?w=800",
    thumbnail: "https://images.unsplash.com/photo-1602022578110-fbfad5644f7f?w=400"
  }
];

export const socialLinks = {
  facebook: "https://www.facebook.com/people/United-Christian-Fellowship/61571373464756/",
  youtube: "https://www.youtube.com/@UnitedChristianFellowship0",
  whatsapp: "https://chat.whatsapp.com/GL9MW2nzhwb50IJslepPpW",
  email: "ucfedmonton@gmail.com",
  phone: "(780) 977-3374"
};
